import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { GOOGLE_MAPS_API } from '../googleMapsAPIClient';
import { GooglePlaceDetail } from '../types';

/**
 * React Query hook to fetch Google Place details by place ID.
 * This hook uses `useMutation` to dynamically fetch place details.
 */
export const useGoogleMapsPlaceDetailsQuery = () => {
  const { mutate, isError, isPending, error } = useMutation<
    GooglePlaceDetail,
    IApiError,
    { placeId: string; language: 'en' }
  >({
    mutationFn: ({ placeId, language }) =>
      GOOGLE_MAPS_API.fetchPlaceDetails(placeId, language),
    mutationKey: ['googleMapsPlaceDetails'],
    retry: 1,
  });

  return {
    error,
    isError,
    isPending,
    mutate,
  };
};
